export const VERSION = "0.1.0";
export const NAME = "fathom";

export * from "./schemas.js";
export { parseSpec } from "./spec-parser.js";
export { scoreComplexity } from "./complexity.js";
export { mapTaskTypes } from "./task-mapper.js";
export { estimateFeature, estimateAll } from "./estimator.js";
export { recommendModel } from "./recommender.js";
export { generateSensitivity } from "./sensitivity.js";
export { generateReport } from "./report.js";
export { generateRegistry, generateRegistryEntry } from "./registry.js";
export { loadData, getProfile, getModelPricing, getComplexityMultiplier, clearCache } from "./data-loader.js";
export type { LoadedData } from "./data-loader.js";
export { scoreComplexityAI } from "./ai-complexity.js";
export type { AIComplexityResult, AIComplexityOptions, GenerateFunction } from "./ai-complexity.js";
export { createOllamaGenerator, isOllamaAvailable } from "./ollama.js";
export type { OllamaOptions } from "./ollama.js";
export { classifyComplexityRuleBased } from "./rule-classifier.js";
export { fetchAdminUsage, resolveAdminKey } from "./admin-usage.js";
export type { AdminUsageReport, UsageBucket, AdminUsageOptions } from "./admin-usage.js";
export {
  prepareContribution,
  previewContribution,
  aggregateContributions,
  exportContribution,
  importCommunityProfiles,
} from "./collective.js";
export type {
  CalibrationDataPoint,
  CommunityProfile,
  CalibratedProfile,
  OverheadActual,
} from "./collective.js";
